import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiTrendingUp, FiHome, FiPackage, FiCheck } from 'react-icons/fi';
import './ServicesSection.css';

const servicesConfig = [
  {
    key: 'investment',
    icon: FiTrendingUp,
    color: '#233147',
    id: 'investment',
    image: 'https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=1200&q=80',
    alt: 'Uluslararası yatırım danışmanlığı toplantısında finansal grafikleri değerlendiren yöneticiler.'
  },
  {
    key: 'construction',
    icon: FiHome,
    color: '#0B1B33',
    id: 'construction',
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80',
    alt: 'Şantiye alanında kasklı mühendisler proje planlarını inceliyor.'
  },
  {
    key: 'materials',
    icon: FiPackage,
    color: '#233147',
    id: 'materials',
    image: 'https://images.unsplash.com/photo-1519710164239-da123dc03ef4?auto=format&fit=crop&w=1200&q=80',
    alt: 'Modern bir depoda organize edilmiş inşaat malzemeleri ve iç mekân çözümleri.'
  }
];

const ServicesSection = () => {
  const { t } = useTranslation();

  return (
    <section className="home-services section-padding">
      <div className="container">
        <motion.div
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2>{t('aboutServices.title')}</h2>
          <p>{t('aboutServices.subtitle')}</p>
        </motion.div>

        <div className="home-services-grid">
          {servicesConfig.map((service, index) => (
            <motion.article
              key={service.key}
              id={service.id}
              className={`home-service-card ${index % 2 === 1 ? 'reverse' : ''}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
            >
              <div className="home-service-media">
                <img src={service.image} alt={service.alt} />
                <span className="home-service-icon" style={{ backgroundColor: service.color }}>
                  <service.icon />
                </span>
              </div>

              <div className="home-service-content">
                <span className="home-service-index">0{index + 1}</span>
                <h3>{t(`services.${service.key}.title`)}</h3>
                <p className="home-service-description">
                  {t(`services.${service.key}.description`)}
                </p>

                <ul className="home-service-items">
                  {t(`services.${service.key}.items`, { returnObjects: true }).map((item, itemIndex) => (
                    <li key={`${service.key}-${itemIndex}`}>
                      <FiCheck className="check-icon" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                <p className="home-service-conclusion">
                  {t(`services.${service.key}.conclusion`)}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
